/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutor_Rooterror_Retry1Inputs */

const en_tutor_rooterror_retry1 = /** @type {(inputs: Tutor_Rooterror_Retry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const fr_tutor_rooterror_retry1 = /** @type {(inputs: Tutor_Rooterror_Retry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Tutor_Rooterror_Retry1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const tutor_rooterror_retry1 = /** @type {((inputs?: Tutor_Rooterror_Retry1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutor_Rooterror_Retry1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tutor_rooterror_retry1(inputs)
	return fr_tutor_rooterror_retry1(inputs)
});
export { tutor_rooterror_retry1 as "tutor_rootError_retry" }